import { render } from "./App.vue?vue&type=template&id=0ff3a118"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0ff3a118&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\NontCO2\\NontRegister-market\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__